export const ruleData = {
  apply_anchor: {
    name: '已申样达人',
    first: '寄样后超',
    last: '天未开播',
  },
  build_anchor: {
    name: '已建联达人',
    first: '建联后超',
    last: '天未申样',
  },
  claim_anchor: {
    name: '已认领线索达人',
    first: '认领后超',
    last: '天未建联',
  },
}
